import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import menuList from './menuList';
import {
  isAdmin,
  isEnabledEmailSchedule,
  isSubAdmin,
  pushToLink,
} from '../../utils/helpers/global';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../routes';
import { getUserRole } from '../../utils/helpers/global';
import useUnsavedChangesWarning from '../../utils/hooks/unsavedWarning';
import { routeConstant, } from '../../constants/app.constants';
import { useDispatch } from 'react-redux';
import {
  botActionTypes,
  companyActionTypes,
  groupsActionTypes,
  loginActionTypes,
  processActionTypes,
  unsavedFormChangesActionTypes,
  userActionTypes,
} from '../../redux/actionTypes';
import styles from './sidebar.module.scss';
import {
  ArrowUPIcon,
  CloseSidebarMenu,
  LogoutIcon,
  LogoutBackground,
  collapsedHeaderLogo,
  headerLogo,
} from '../../assets';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import CustomDrawer from '../../components/CustomDrawer/CustomDrawer';
import { GradientButton } from '../../components/GradientButton/GradientButton';
const Sidebar = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { unsavedChanges, updateChangeState, checkForFormUpdates } = useUnsavedChangesWarning();
  const { collapsed, onCollapse } = props;
  const { Sider } = Layout;
  const { SubMenu } = Menu;
  const [defaultSelectedKey, setDefaultSelectedKey] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [navigationLink, setNavigationLink] = useState('');
  const [openKeys, setOpenKeys] = useState([]); // Track open submenu keys
  const content = menuList[getUserRole()] ? menuList[getUserRole()] : [];
  const dispatch = useDispatch();

  const handleDispatch = (link) => {
    switch (link) {
      case routeConstant.USER_VIEW_PATH:
        dispatch({ type: userActionTypes.GET_USER_BACKBTN_FAILURE });
        break;
      case routeConstant.COMPANY_VIEW_PATH:
        dispatch({ type: companyActionTypes.GET_BACKBTN_FAILURE });
        break;
      case routeConstant.GROUPS_VIEW:
        dispatch({ type: groupsActionTypes.GET_GROUP_BACKBTN_FAILURE });
        break;
      case routeConstant.BOT_VIEW_PATH:
        dispatch({ type: botActionTypes.GET_BOT_BACKBTN_FAILURE });
        break;
      case routeConstant.SCHEDULE_HISTORY_VIEW_PATH:
      case routeConstant.SCHEDULE_VIEW_PATH:
        dispatch({ type: processActionTypes.GET_SCHEDULE_BACKBTN_FAILURE });
        break;
      default:
        break;
    }
  };
  const handleItemChange = (link, key) => {
    handleDispatch(link);
    if (link !== location.pathname) {
      if (!unsavedChanges || !checkForFormUpdates()) {
        pushToLink(history, link);
        collapsed && setDefaultSelectedKey('');
        collapsed && setOpenKeys([]);
      } else if (unsavedChanges && checkForFormUpdates()) {
        setShowAlert(true);
        setNavigationLink(link);
        collapsed && setDefaultSelectedKey('');
        collapsed && setOpenKeys([]);
      }
    }
  };
  const handleConfirm = (status) => {
    if (status) {
      pushToLink(history, navigationLink);
      updateChangeState(false);
    }
    setShowAlert(false);
  };
  const handleLogout = () => {
    dispatch({ type: loginActionTypes.LOGOUT });
    dispatch({ type: unsavedFormChangesActionTypes.RESET_FORM_CHANGES });
    localStorage.setItem('logout', Date.now().toString());
    setOpenLogout(false);
    history.push('/');
  };
  const handleOpenLogout = () => {
    setOpenLogout(true);
  };
  const handleCloseLogout = () => {
    setOpenLogout(false);
  };
  useEffect(() => {
    const url = history.location.pathname;
    const route = routes[getUserRole()]
      ? routes[getUserRole()].find((item) => item.path === url)
      : [];
    route ? setDefaultSelectedKey([`${route.key}`]) : setDefaultSelectedKey('');
  }, [history.location.pathname]);

  return (
    <div
      className={`${styles.sidebar} ${!collapsed ? styles.backdrop : ''}`}
      onClick={() => {
        !collapsed && onCollapse((prevState) => !prevState);
      }}
    >
      <Sider
        collapsed={collapsed}
        onCollapse={onCollapse}
        width={220}
        collapsedWidth={60}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={styles.headerLogo}>
          {collapsed ? <img src={collapsedHeaderLogo} /> : <img src={headerLogo} />}
        </div>
        <Menu
          mode="inline"
          className={styles.menuContainer}
          selectedKeys={[`${defaultSelectedKey}`]}
          openKeys={openKeys}
          onOpenChange={(keys) => {
            let data = keys.length > 0 ? keys[keys.length - 1] : [];
            return setOpenKeys([data]);
          }}
          expandIcon={<ArrowUPIcon />}
        >
          {!!content.length &&
            content.map((item) => {
              return item.children && !!item.children.length ? (
                <SubMenu key={item.key} icon={item.icon} title={item.title} className={styles.menu}>
                  {item.children.map((i) => {
                    if (i.key === 62 && !(isAdmin() || isSubAdmin()) && !isEnabledEmailSchedule())
                      return null;
                    return (
                      <Menu.Item
                        key={i.key}
                        icon={i.icon}
                        className={styles.menu}
                        onClick={() => handleItemChange(i.link)}
                      >
                        {i.content}
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  className={styles.menu}
                  onClick={() => handleItemChange(item.link)}
                >
                  {item.content}
                </Menu.Item>
              );
            })}
          <Menu.Item
            key="logout"
            icon={<LogoutIcon className="menuIcon" />}
            className={`${styles.menu} ${styles.logoutMenuItem}`}
            onClick={handleOpenLogout}
          >
            Logout
          </Menu.Item>
        </Menu>
        <div
          onClick={() => onCollapse((prevState) => !prevState)}
          className={styles.expandButton}
        >
          <CloseSidebarMenu className={styles.expandIcon} />
        </div>
      </Sider>
      <div onClick={(event) => event.stopPropagation()}>
        <ConfirmationModal
          open={showAlert}
          setOpen={setShowAlert}
          onConfirm={() => handleConfirm(true)}
          onCancel={() => handleConfirm(false)}
        />
        <CustomDrawer
          open={openLogout}
          onClose={handleCloseLogout}
          title="Confirm Logout"
          isBackdropClosable
        >
          <div className={styles.logoutForm}>
            <LogoutBackground className={styles.formBackground} />
            <p className={styles.logOutMessage}>Are you sure you want to logout?</p>
            <div className={styles.buttonContainer}>
              <GradientButton
                variant="outline"
                className={styles.actionButton}
                onClick={handleCloseLogout}
              >
                Cancel
              </GradientButton>
              <GradientButton className={styles.actionButton} onClick={handleLogout}>
                Yes
              </GradientButton>
            </div>
          </div>
        </CustomDrawer>
      </div>
    </div>
  );
};

export default Sidebar;
